module.exports = __webpack_public_path__ + "img/meyers-header.50ac5f67.jpg";